import {
  useWaffle,
  WaffleContextValue,
} from "@shared/contexts/WaffleContext/WaffleContext";

const useDjangoWaffle = (): WaffleContextValue => {
  const waffle = useWaffle();
  return waffle;
};

export default useDjangoWaffle;
